import { render, staticRenderFns } from "./Fallback.vue?vue&type=template&id=07973e1e&"
import script from "./Fallback.vue?vue&type=script&lang=js&"
export * from "./Fallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports